<template>
  <div class="im-message" :class="{ right: isMe }">
    <div class="avatar left">
      <img v-if="!isMe" :src="avatar" class="avatar-img" @error="onError2" />
    </div>
    <div class="message-content">
      <div v-if="isMe" class="read-receipts">
        <!-- <div v-if="message.isPeerRead">已读</div>
        <div v-else>未读</div> -->
        <!-- <uni-icons
          v-if="message.loading"
          class="message-error"
          type="spinner-cycle"
          size="20"
        /> -->
        <icon v-if="message.fail" class="message-error" type="warn" size="20" />
      </div>
      <!-- 文本 -->
      <im-text-message
        v-if="message.type === TIM_TYPE.MSG_TEXT"
        :message="message"
        @menu="onLongpress"
      />
      <!-- 图片 -->
      <im-image-message
        v-if="message.type === TIM_TYPE.MSG_IMAGE"
        :message="message"
        :message-list="messageList"
        @menu="onLongpress"
      />
      <!-- 语音 -->
      <im-audio-message
        v-if="message.type === TIM_TYPE.MSG_AUDIO"
        :message="message"
        @play="onPlay"
        @menu="onLongpress"
      />

      <!-- 表情 -->
      <!-- <im-image-message
      v-if="message.type === TIM_TYPE.MSG_IMAGE"
      class="message-content"
    ></im-image-message> -->
      <!-- 视频文件 -->
      <im-video-file-message v-if="message.type === TIM_TYPE.MSG_VIDEO" :message="message" />
      <!-- 文件消息 -->
      <im-file-message v-if="message.type === TIM_TYPE.MSG_FILE" :message="message" />
      <!-- 自定义消息 -->
      <im-custom-message
        v-if="message.type === TIM_TYPE.MSG_CUSTOM"
        :message="message"
        class="custom-message"
      />
    </div>
    <div class="avatar">
      <img v-if="isMe" :src="avatarMe" class="avatar-img" @error="onError1" />
    </div>
  </div>
</template>

<script>
import { TIM_TYPE } from '@/timpackage/utils/timInit'
import { mapState } from 'vuex'
import avatar1 from '@/static/doctor_default_avatar@2x.png' // 默认医生头像
import avatar2 from '@/static/patient_default@2x.png' // 默认病人头像
export default {
  name: 'imMessage',
  props: {
    message: {
      type: Object,
      default() {
        return {}
      }
    },
    messageList: {
      // 获取消息列表，预览列表图片
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      TIM_TYPE,
      avatar1,
      avatar2,
      defaultAvatar1: '',
      // 'https://pharmacyimg.docbook.com.cn/mini_patient/default-photo.jpg', // 医生
      defaultAvatar2: ''
      // 'https://pharmacyimg.docbook.com.cn/mini_patient/defaultUser.png' // 受者
    }
  },
  computed: {
    ...mapState('IM', ['avatarUrl', 'headPortrait']),
    isMe() {
      // 手术自定义消息特殊处理
      // 手术自定义消息特殊处理
      // 手术自定义消息特殊处理
      if (this.message.payload && this.message.payload.data) {
        let temp = {}
        try {
          temp = JSON.parse(this.message.payload.data)
        } catch (e) {
          temp = {
            type: ''
          }
        }
        if (Number(temp.type) === 35) {
          return true
        }
      }
      return this.message.flow === 'out'
    },
    avatar() {
      return this.defaultAvatar1 || this.headPortrait || this.avatar2
    },
    avatarMe() {
      return this.defaultAvatar2 || this.avatarUrl || this.avatar1
    }
  },
  created() {},
  methods: {
    onLongpress(data) {
      // 长按-消息菜单
      this.$emit('menu', data)
    },
    onError1(e) {
      this.defaultAvatar2 = this.avatar1
      // 'https://pharmacyimg.docbook.com.cn/mini_patient/default-photo.jpg' // 医生
    },
    onError2(e) {
      this.defaultAvatar1 = this.avatar2
      // 'https://pharmacyimg.docbook.com.cn/mini_patient/defaultUser.png' // 受者
    },
    onPlay({ message, cb }) {
      this.$emit('play', { message, cb })
    }
  }
}
</script>

<style lang="scss" scoped>
.im-message {
  box-sizing: border-box;
  position: relative;
  display: flex;
  padding: 0.682667rem 0 0.256rem;

  &.right {
    .message-content {
      // text-align: right;
      justify-content: flex-end;
    }
  }

  .avatar {
    display: flex;
    flex: 0 0 2.346667rem;
    width: 2.346667rem;
    border-radius: 60%;

    .avatar-img {
      display: block;
      width: 1.664rem;
      height: 1.664rem;
      border-radius: 60%;
    }

    &.left {
      justify-content: flex-end;
    }
  }

  .custom-message {
    flex: 1; // 自定义消息自动占满一行，bug12648
  }

  .read-receipts {
    margin-right: 0.213333rem;
    display: flex;
    align-items: center;
    // line-height: .896rem;
    height: 0.896rem;
    font-size: 0.256rem;
    color: #6e7981;
    white-space: nowrap;
  }

  .message-content {
    margin-left: 0.597333rem;
    margin-right: 0.597333rem;
    flex: 1;
    display: flex;
    align-items: center;
  }
}
</style>
